module.exports = __webpack_public_path__ + "img/SPPlusMetropolisLogo.ee95103a.svg";